import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import React from 'react';
import { replaceWhiteSpace } from '../../utils';
import LocalizedLink from '../primitives/LocalizedLink';

interface IObjectMenu {
    title: string;
    link: string;
    isLitteral?: boolean;
}

export default function Sidenavmenu(props: {
    t: any;
    states: any;
    accessories: Map<any, any>;
    ventings: Map<any, any>;
}) {
    const { t, states, accessories, ventings } = props;
    // devra venir de Studio ?
    const sidenavMenuData = {
        [t('meta-titles.appliances')]: {
            'wood-stoves': {
                title: t('wood-stoves'),
                link: '/wood-stoves/',
            },
            'appliance-pellet-stoves': {
                title: t('appliance-pellet-stoves'),
                link: '/pellet-stoves/',
            },
            'wood-inserts': {
                title: t('wood-inserts'),
                link: '/wood-inserts/',
            },
            'wood-furnaces': {
                title: t('wood-furnaces'),
                link: '/wood-furnaces/',
            },
            'wood-cook-stoves': {
                title: t('wood-cook-stoves'),
                link: '/cook-stoves/',
            },
            'outdoor-fireplaces': {
                title: t('outdoor-fireplaces'),
                link: '/outdoor-fireplaces/',
            },
        },
        [t('meta-titles.ventings')]: Array.from(ventings)[0][1]
            .sort((a: any, b: any) => a.label > b.label)
            .map(
                (single: { label: string; slug: string; category: string }) => {
                    const category = replaceWhiteSpace(
                        single.category.split('/')[3].toLowerCase(),
                        '-'
                    );
                    return {
                        title: single.label,
                        link: `/venting/${category}/`,
                        isLitteral: true,
                    };
                }
            ),
        [t('meta-titles.accessories')]: Array.from(accessories)[0][1]
            .sort((a: any, b: any) => a.label > b.label)
            .map((single: { label: string; slug: string }) => {
                const slug = single.slug.split('/').join('/?type=');
                return {
                    title: single.label,
                    link: `/${slug}`,
                    isLitteral: true,
                };
            }),
        [t('meta-titles.replacement-parts')]: {
            title: 'empty',
            link: '/archives/',
        },
        [t('meta-titles.support-service')]: {
            'where-to-buy': {
                title: t('where-to-buy'),
                link: '/where-to-buy/',
            },
            'find-retailer': {
                title: 'find-retailer',
                link: '/find-retailer/',
            },
            warranty: {
                title: 'warranty',
                link: '/warranty/stoves-inserts/',
            },
            contact: {
                title: t('contact'),
                link: '/contact/',
            },
            about: {
                title: t('about'),
                link: '/about/',
            },
            'gov-incentives': {
                title: t('gov-incentives'),
                link: '/gov-incentives/',
            },
            manuals: {
                title: t('manuals'),
                link: '/archives/',
            },
            videos: {
                title: 'videos',
                link: '/videos/',
            },
            faq: {
                title: 'faq',
                link: '/faq/wood-stoves/',
            },
            blog: {
                title: t('blog'),
                link: '/blogArchives/',
            },
        },
    };

    return (
        <div className='navbar'>
            {Object.entries(sidenavMenuData).map((menuData, index: number) => {
                const isOpen = states?.[index]?.isOpen;
                return (
                    <div key={index} className='subnav'>
                        <div
                            className={`nav-title ${isOpen && 'open'}`}
                            onClick={() => states?.[index]?.setIsOpen(!isOpen)}
                        >
                            {!isEmpty() ? (
                                <>
                                    <span className='title '>
                                        {menuData[0]}
                                    </span>
                                    <FontAwesomeIcon
                                        className={`icon ${isOpen && 'open'}`}
                                        icon={
                                            isOpen ? faChevronUp : faChevronDown
                                        }
                                    />
                                </>
                            ) : (
                                <LocalizedLink
                                    className='title no-sub-menu'
                                    to={menuData[1].link ?? '#'}
                                    label={menuData[0]}
                                />
                            )}
                        </div>

                        {isOpen && (
                            <div className='nav-items'>
                                {Object.values(menuData[1]).map(
                                    (
                                        objectMenu: IObjectMenu | any,
                                        index: number
                                    ) => {
                                        return (
                                            <LocalizedLink
                                                key={index}
                                                className='nav-item'
                                                to={objectMenu?.link}
                                                label={
                                                    objectMenu?.isLitteral
                                                        ? `${objectMenu?.title}`
                                                        : t(
                                                              `meta-titles.${objectMenu?.title}`
                                                          )
                                                }
                                            />
                                        );
                                    }
                                )}
                            </div>
                        )}
                    </div>
                );

                function isEmpty() {
                    return menuData?.[1]?.title === 'empty';
                }
            })}
        </div>
    );
}
